import React, { useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Spinner, Alert, AlertIcon, useMediaQuery, useToast } from "@chakra-ui/react";
import BGLogin from "./assets/images/image_login.png";
import LogoImg from "./assets/images/Logo-PNG.png";
import OpenEyeImg from "./assets/images/open_eye.png";
import CloseEyeImg from "./assets/images/close_eye.png";
import PasswordIconImg from "./assets/images/mdi_password-outline.png";
import LogoFooterImg from "./assets/images/logo_footer.png";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [registerStatusAlert, setRegisterStatusAlert] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showImagePanel] = useMediaQuery("(min-width: 769px)");
  const toast = useToast();
  const history = useHistory();
  const token = new URLSearchParams(useLocation().search).get("token");

  async function submit() {
    if (password !== confirmPassword) {
      setRegisterStatusAlert(
        <Alert status="warning" borderRadius="5px">
          <AlertIcon />
          Las contraseñas no coinciden.
        </Alert>
      );
      return;
    }
    setLoading(true);
    setRegisterStatusAlert(null);

    var body = {
      password: password,
      token: token,
    };

    var response = await fetch("user/resetPassword", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    var jsonRes = await response.json();

    switch (jsonRes.error) {
      case false:
        setRegisterStatusAlert(
          <Alert status="success" borderRadius="5px">
            <AlertIcon />
            El cambio de contraseña finalizo con exito!&nbsp;
            <Link to="/Login"> Ingresar</Link>
          </Alert>
        );
        break;
      case true:
        setRegisterStatusAlert(
          <Alert status="warning" borderRadius="5px">
            <AlertIcon />
            {jsonRes.message}
          </Alert>
        );
        break;
      default:
        break;
    }
    setTimeout(() => {
      setLoading(false);
      toast({
        title: "Exito!.",
        description: "Se cambio la contraseña correctamente.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    }, 1000);
    setLoading(false);
    history.push("/");
  }

  const inputStyle = { border: "none", outline: "none", flex: 1, fontSize: 15, color: "#333", background: "transparent", textAlign: "center" };
  const inputWrapperStyle = { display: "flex", alignItems: "center", border: "1px solid rgba(98, 134, 172, 0.5)", borderRadius: 8, padding: "12px 16px", background: "#fff" };
  const iconStyle = { width: 20, height: 20, marginRight: 12, flexShrink: 0 };
  const inputContainerStyle = { width: "100%", marginBottom: 16, position: "relative" };

  return (
    <div style={{ display: "flex", minHeight: "100vh", fontFamily: "Arial, sans-serif" }}>
      <style>{`.login-input { text-align: center; }.login-input::placeholder { text-align: center; }`}</style>
      {/* Left side - Form */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between", padding: "40px 60px", background: "#fff" }}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", maxWidth: 500, margin: "0 auto", width: "100%", paddingTop: 100 }}>
          {/* Logo */}
          <div style={{ textAlign: "center", marginBottom: 45 }}>
            <img src={LogoImg} alt="Hospital Británico" style={{ maxHeight: 80, width: "auto" }} />
          </div>

          {/* Title */}
          <h1 style={{ fontWeight: 600, fontSize: 24, lineHeight: "24px", letterSpacing: "0%", textAlign: "center", color: "#004890", marginBottom: 45 }}>Ingrese nueva contraseña</h1>

          {/* Password input */}
          <div style={inputContainerStyle}>
            <div style={inputWrapperStyle}>
              <img src={PasswordIconImg} alt="" style={iconStyle} />
              <input
                className="login-input"
                type={showPassword ? "text" : "password"}
                placeholder="Contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={inputStyle}
              />
              {showPassword ? (
                <img src={OpenEyeImg} alt="Ocultar contraseña" style={{ width: 20, height: 20, cursor: "pointer", flexShrink: 0 }} onClick={() => setShowPassword(false)} />
              ) : (
                <img src={CloseEyeImg} alt="Mostrar contraseña" style={{ width: 20, height: 20, cursor: "pointer", flexShrink: 0 }} onClick={() => setShowPassword(true)} />
              )}
            </div>
          </div>

          {/* Confirm Password input */}
          <div style={{ ...inputContainerStyle, marginBottom: 20 }}>
            <div style={inputWrapperStyle}>
              <img src={PasswordIconImg} alt="" style={iconStyle} />
              <input
                className="login-input"
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Repita Contraseña"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                style={inputStyle}
              />
              {showConfirmPassword ? (
                <img src={OpenEyeImg} alt="Ocultar contraseña" style={{ width: 20, height: 20, cursor: "pointer", flexShrink: 0 }} onClick={() => setShowConfirmPassword(false)} />
              ) : (
                <img src={CloseEyeImg} alt="Mostrar contraseña" style={{ width: 20, height: 20, cursor: "pointer", flexShrink: 0 }} onClick={() => setShowConfirmPassword(true)} />
              )}
            </div>
          </div>

          {/* Alert */}
          {registerStatusAlert && <div style={{ width: "100%", marginBottom: 16 }}>{registerStatusAlert}</div>}

          {/* Submit button */}
          <button
            type="button"
            onClick={submit}
            disabled={loading}
            style={{
              width: "100%",
              padding: "14px",
              background: "#004890",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              fontSize: 16,
              fontWeight: 600,
              cursor: loading ? "not-allowed" : "pointer",
              marginBottom: 30,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
            }}
          >
            {loading ? <Spinner size="sm" color="white" /> : "Recuperar contraseña"}
          </button>

          {/* Login link */}
          <Link to="/" style={{ color: "#004890", fontSize: 14 }}>
            Volver al inicio de sesión
          </Link>
        </div>

        {/* Footer */}
        <div style={{ textAlign: "center", padding: "20px 0", fontSize: 13, color: "#999", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
          <img src={LogoFooterImg} alt="Hospital Británico" style={{ height: 14, width: 35 }} />
          <span>Hospital Británico | © 2025</span>
        </div>
      </div>

      {/* Right side - Image */}
      {showImagePanel && (
        <div style={{ flex: 1, position: "relative", overflow: "hidden", display: "flex", flexDirection: "column" }}>
          <img
            src={BGLogin}
            alt="Portal de prestadores"
            style={{ width: "100%", height: "100%", position: "fixed" }}
          />
          <div
            style={{
              position: "absolute",
              bottom: 150,
              left: 0,
              right: 0,
              background: "linear-gradient(180deg, #020A14,#395D84 )",
              padding: "40px 50px",
              color: "#fff",
              textAlign: "center",
              opacity: 0.6,
            }}
          >
            <h2 style={{ fontWeight: 600, fontSize: "39.84px", lineHeight: "48px", letterSpacing: 0, textAlign: "center", color: "#FFFFFF", marginBottom: 10 }}>
              Bienvenido al portal de <br /> prestadores
            </h2>
            <p style={{ fontWeight: 600, fontSize: "19.84px", lineHeight: "24px", letterSpacing: "0%", textAlign: "center", verticalAlign: "middle", opacity: 0.9 }}>
              Donde podrás Realiza tus tramites y gestiones online
              <br />
              de manera sencilla.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ResetPassword;
